export enum DsrResourceType {
  Editor = 'Editor',
  DsrTemplate = 'DsrTemplate',
  Directory = 'Directory',
  All = '',
}
